import abortControllerTypes from '../consts/abortControllerTypes';
import {selectIsOnline} from '../state/selectors/global';
import {getState} from '../state/store';
import helpers from '../utils/helpers';

const waitOnline = async () => {
    const isOnline = selectIsOnline(getState());

    if (isOnline) return;

    const CHECK_ONLINE_INTERVAL = 100;

    await helpers.timeout(CHECK_ONLINE_INTERVAL);

    await waitOnline();
};

const checkIsOnline = () => {
    const isOnline = selectIsOnline(getState());

    if (!isOnline) {
        throw new Error('Internet connection is offline');
    }
};

const getIsOfflineError = (error) => !selectIsOnline(getState()) || error?.code === abortControllerTypes.ERR_NETWORK;

const networkStatusService = {
    waitOnline,
    checkIsOnline,
    getIsOfflineError,
};

export default networkStatusService;
